export default __webpack_public_path__ + "static/media/foam-roller.0b970621.png";